import { AppBar, Box, Container, Grid, Toolbar } from '@mui/material';
import { useWindow, BackButton } from '@xolv-mybrightlink/common';
import { useState } from 'react';

interface SecuritySkeletonProps {
  onBackPressed?: () => void;
  children: React.ReactNode;
}

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
};

export const SecuritySkeleton = (props: SecuritySkeletonProps) => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions(),
  );

  useWindow(() => setWindowDimensions(getWindowDimensions()));

  return (
    <Grid
      container
      minHeight={windowDimensions.height}
      direction='column'
      justifyContent='space-between'
    >
      <Grid item sx={{ zIndex: 10 }}>
        <AppBar color='transparent' position='static' elevation={0}>
          <Toolbar sx={{ marginLeft: 5, marginTop: 5 }}>
            {props.onBackPressed && (
              <BackButton onBackPressed={props.onBackPressed} />
            )}
          </Toolbar>
        </AppBar>
        <Container component='main' maxWidth='sm'>
          <Box
            sx={{
              px: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <img src='/public/assets/images/logo_mbl.svg' />
            {props.children}
            <img
              src='/public/assets/images/logo_xolv.svg'
              style={{
                marginTop: '50px',
                width: '100px',
              }}
            />
          </Box>
        </Container>
      </Grid>
      <Grid
        item
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          width: '100vw',
          height: '100vh',
          position: 'fixed',
          left: 0,
          bottom: 0,
          zIndex: 0,
        }}
      >
        <img
          src='/public/assets/images/illustration_login.svg'
          style={{
            width: '100%',
            height: '100%',
          }}
        />
      </Grid>
    </Grid>
  );
};
